<bui-group>
	<bui-field>
		{{ 'adblock.detected.text1' | msgKey }}
		<br> {{ 'adblock.detected.text2' | msgKey }}
		<br> {{ 'adblock.detected.text3' | msgKey }}
		<br> {{ 'hotline.fragen' | msgKey }}{{ 'hotline.telefon.secondlevel' | msgKey }}.
	</bui-field>
</bui-group>
<bui-button-line>
	<p-button (onClick)="dialogRef.close()"
	          severity="primary">{{ 'button.ok.alt' | msgKey }}
	</p-button>
</bui-button-line>